import { Link } from "wouter";
import { Play, ArrowUpRight } from "lucide-react";
import { GOOGLE_PLAY_URL, trackGooglePlayClick } from "@/lib/analytics";

export function Footer() {
  return (
    <footer className="mt-12 rounded-t-[3rem] bg-foreground pb-10 pt-20 text-background sm:mt-20">
      <div className="site-container">
        <div className="mb-20 grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Link data-testid="link-footer-brand-home" href="/" className="mb-6 inline-flex items-center gap-3 group">
              <div className="w-10 h-10 rounded-xl bg-primary text-primary-foreground flex items-center justify-center font-heading font-bold text-2xl group-hover:scale-105 transition-transform shadow-lg shadow-primary/20">
                P
              </div>
              <span className="font-heading font-bold text-3xl tracking-tight">Proteo</span>
            </Link>
            <p data-testid="text-footer-description" className="mb-8 max-w-md text-lg leading-relaxed text-background/70">
              The AI protein tracker built for long-term nutrition habits. Snap a photo, get evidence-aware estimates, and keep a clearer picture of your meals over time.
            </p>
            <a 
               href={GOOGLE_PLAY_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackGooglePlayClick('footer')}
              data-testid="link-google-play-footer"
               aria-label="Get Proteo on Google Play"
               className="inline-flex min-h-12 items-center gap-2 rounded-full bg-primary px-6 py-3.5 text-sm font-bold text-primary-foreground shadow-xl shadow-primary/20 transition-all hover:-translate-y-0.5 hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary active:scale-95"
            >
              <Play className="w-4 h-4 fill-current" />
                <span>Get it on Google Play</span>
            </a>
          </div>
          
          <div className="lg:col-span-2 lg:col-start-8">
            <h4 className="font-heading font-bold text-lg mb-6 text-background/50 uppercase tracking-wider text-sm">Product</h4>
            <ul className="space-y-4">
              <li><a href="/#how-it-works" className="font-semibold text-background/80 hover:text-white transition-colors flex items-center gap-1 group">How it works <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity -ml-1 group-hover:ml-0" /></a></li>
              <li><a href="/#capabilities" className="font-semibold text-background/80 hover:text-white transition-colors flex items-center gap-1 group">Capabilities <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity -ml-1 group-hover:ml-0" /></a></li>
              <li><a href="/#pricing" className="font-semibold text-background/80 hover:text-white transition-colors flex items-center gap-1 group">Pricing <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity -ml-1 group-hover:ml-0" /></a></li>
              <li><a href="/longevity/" className="font-semibold text-background/80 hover:text-white transition-colors flex items-center gap-1 group">Longevity Hub <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity -ml-1 group-hover:ml-0" /></a></li>
            </ul>
          </div>
          
          <div className="lg:col-span-2">
            <h4 className="font-heading font-bold text-lg mb-6 text-background/50 uppercase tracking-wider text-sm">Legal</h4>
            <ul className="space-y-4">
              <li><Link href="/privacy" className="font-semibold text-background/80 hover:text-white transition-colors flex items-center gap-1 group">Privacy Policy <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity -ml-1 group-hover:ml-0" /></Link></li>
              <li><Link href="/terms" className="font-semibold text-background/80 hover:text-white transition-colors flex items-center gap-1 group">Terms of Service <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity -ml-1 group-hover:ml-0" /></Link></li>
              <li><a href="/dashboard/support" className="font-semibold text-background/80 hover:text-white transition-colors flex items-center gap-1 group">Contact Support <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity -ml-1 group-hover:ml-0" /></a></li>
            </ul>
          </div>
        </div>
        
          <div className="flex flex-col items-start justify-between gap-4 border-t border-background/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-background/40 font-medium text-sm">
            © {new Date().getFullYear()} Frontier International. All rights reserved.
          </p>
          <div className="text-background/40 font-medium text-sm flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
            Designed for those who plan to stay active
          </div>
        </div>
      </div>
    </footer>
  );
}
